import {
  Action, getModule, Module, Mutation, VuexModule,
} from 'vuex-module-decorators';
import {
  divide, join, map, pad, padStart,
} from 'lodash';
import { format } from 'date-fns';

// eslint-disable-next-line
import store from '@/store';
import { E_IRA } from '@/constants/repository';
import EIRAItem, { EIRAItemProps } from '@/models/EIRAItem';
import { download } from '@/utils/download';

function formatAmount(amount: number): string {
  return padStart(amount.toFixed(2), 14, '0');
}

@Module({
  name: E_IRA,
  namespaced: true,
  store,
  dynamic: true,
})
class EIRAModule extends VuexModule {
  items: EIRAItem[] = [];

  @Mutation
  public ADD_ITEM(item: EIRAItemProps) {
    this.items.push(new EIRAItem(item));
  }

  @Action
  public generate() {
    const text = join(
      map(this.items, (item: EIRAItem) => {
        const partyId = pad('', 11, '0');
        const synesisCode = padStart(`${item.payer.synesisCode}`, 7, '0');
        const invoiceId = padStart(item.invoiceId, 15, '0');
        const invoiceDate = format(item.invoiceDate, 'ddMMyyyy');
        const invoiceDueDate = format(item.invoiceDueDate, 'ddMMyyyy');
        const invoiceAmount = formatAmount(divide(item.amount, 100));
        const interestAmount = formatAmount(divide(item.interest, 100));

        const baseAmount = divide(item.baseAmount, 100);
        const taxAmount = divide(item.taxAmount, 100);

        const baseAmount5 = formatAmount(item.taxRate === 0.05 ? baseAmount : 0);
        const taxAmount5 = formatAmount(item.taxRate === 0.05 ? taxAmount : 0);

        const baseAmount13 = formatAmount(item.taxRate === 0.13 ? baseAmount : 0);
        const taxAmount13 = formatAmount(item.taxRate === 0.13 ? taxAmount : 0);

        const baseAmount25 = formatAmount(item.taxRate === 0.25 ? baseAmount : 0);
        const taxAmount25 = formatAmount(item.taxRate === 0.25 ? taxAmount : 0);

        const taxFreeAmount = formatAmount(0);

        return `${partyId}${synesisCode}${invoiceId}${invoiceDate}${invoiceDueDate}${invoiceAmount}${interestAmount}${baseAmount5}${taxAmount5}${baseAmount13}${taxAmount13}${baseAmount25}${taxAmount25}${taxFreeAmount}`;
      }),
      '\n',
    );

    download(text, 'eIRA.txt');
  }
}

export default getModule(EIRAModule);
